import { useQuery } from "@tanstack/react-query";
import { mateApi } from "@/api/mateApi";
import { MateLatestWorkoutResponse } from "@/types/mateTypes";

/**
 * Custom hook to fetch a mate's latest workout data
 *
 * @param mateshipId - The ID of the mate relationship
 * @returns Query result with mate's latest workout data
 */
export function useMateLatestWorkout(mateshipId: string | undefined) {
  return useQuery<MateLatestWorkoutResponse>({
    queryKey: ["mate-latest-workout", mateshipId],
    queryFn: () => {
      if (!mateshipId) {
        throw new Error("Mateship ID is required");
      }
      return mateApi.getMateLatestWorkout(mateshipId);
    },
    enabled: !!mateshipId, // Only run query if mateshipId is provided
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
  });
}

